var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"items-chip",attrs:{"small":"","color":"lightGrey"}},[_c('Typography',{attrs:{"variant":"caption-1"}},[_vm._v(_vm._s(_vm.chipLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }